/**
 * Вспомогательные функции для рендеринга истории:
 * утилиты форматирования, построение дерева, вычисление активной цепочки.
 */

// Получить название словаря из результатов поиска.
// Приоритет: раскрытая статья (.zaglavie.expanded) → первый результат (fallback).
function getDictNameFromResults() {
  try {
    // Приоритет: раскрытая (expanded) статья — это то, что юзер реально смотрит
    var expanded = document.querySelector('.zaglavie.expanded');
    var target = expanded ? expanded.closest('.opredelenie') : null;

    // Fallback: первый результат
    if (!target) {
      target = document.querySelector('.opredelenie');
    }

    if (target) {
      var dictElement = target.querySelector('.dictname, [data-dict-name]');
      if (dictElement) {
        var dictName = dictElement.getAttribute('data-dict-name');
        if (dictName && dictName.trim()) return dictName.trim();
        var textContent = dictElement.textContent.trim();
        if (textContent) return textContent;
      }
      var fallbackElement = target.querySelector('.dict-name, [data-dict]');
      if (fallbackElement) {
        return fallbackElement.textContent.trim() || fallbackElement.getAttribute('data-dict') || '';
      }
    }
    return '';
  } catch (e) {
    return '';
  }
}

// ---- Tree helpers ----

// Always the quote-safe history escaper (BL-050), never a shadowed global or the identity.
function _safeEscape(text) {
  if (typeof window.historyEscapeHtml === 'function') {
    return window.historyEscapeHtml(text);
  }
  return String(text === null || text === undefined ? '' : text)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _formatLangLabel(lang) {
  if (!lang) return 'EN';
  var l = String(lang).toLowerCase();
  if (l === 'ru') return 'RU';
  if (l === 'en') return 'EN';
  if (l === 'de') return 'DE';
  if (l === 'fr') return 'FR';
  return l.toUpperCase();
}

function _formatDate(ts) {
  if (!ts) return '';
  var date = new Date(ts);
  return String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0');
}

/**
 * Строит дерево из плоского массива истории.
 * Возвращает массив корневых узлов, каждый с polem children[].
 * Узел: {item, children, rootId, maxTs}
 *
 * Orphan-записи (parentId указывает на удалённый item) превращаются в корни.
 */
function _buildHistoryTree(history) {
  var map = {};
  var nodes = {};
  history.forEach(function(it) {
    map[it.id] = it;
    nodes[it.id] = { item: it, children: [], rootId: null, maxTs: it.timestamp || 0 };
  });

  var roots = [];
  history.forEach(function(it) {
    var node = nodes[it.id];
    if (it.parentId && nodes[it.parentId]) {
      nodes[it.parentId].children.push(node);
    } else {
      roots.push(node);
    }
  });

  // Заполняем rootId и maxTs (recursive DFS)
  function assign(node, rootId) {
    node.rootId = rootId;
    var localMax = node.item.timestamp || 0;
    node.children.forEach(function(ch) {
      assign(ch, rootId);
      if (ch.maxTs > localMax) localMax = ch.maxTs;
    });
    node.maxTs = localMax;
  }
  roots.forEach(function(r) { assign(r, r.item.id); });

  // Сортировка: корни по maxTs DESC (ветки с недавней активностью сверху).
  // Дети внутри ветки — по timestamp ASC (хронологически, чтобы читалось как путь прояснения).
  roots.sort(function(a, b) { return b.maxTs - a.maxTs; });
  function sortChildren(node) {
    node.children.sort(function(a, b) { return (a.item.timestamp || 0) - (b.item.timestamp || 0); });
    node.children.forEach(sortChildren);
  }
  roots.forEach(sortChildren);

  return { roots: roots, nodes: nodes };
}

/**
 * Возвращает set id предков (включая сам id) для активной записи.
 * Используется для подсветки «активной цепочки прояснения».
 */
function _computeActiveChain(activeId, nodes) {
  var chain = {};
  if (!activeId || !nodes[activeId]) return chain;
  var history = getHistory();
  var byId = {};
  history.forEach(function(it) { byId[it.id] = it; });

  // ТОЛЬКО вверх: от active до корня (предки).
  // Потомков НЕ включаем — они не на пути "как я сюда попал".
  var cur = byId[activeId];
  var guard = 0;
  while (cur && guard < 100) {
    chain[cur.id] = true;
    if (!cur.parentId) break;
    cur = byId[cur.parentId];
    guard++;
  }

  return chain;
}

// Рекурсивно считаем всех потомков ветки.
function _countDescendants(node) {
  var n = 0;
  node.children.forEach(function(ch) {
    n += 1 + _countDescendants(ch);
  });
  return n;
}

window.getDictNameFromResults = getDictNameFromResults;
window._buildHistoryTree = _buildHistoryTree;
window._computeActiveChain = _computeActiveChain;
window._countDescendants = _countDescendants;
window._safeEscape = _safeEscape;
window._formatLangLabel = _formatLangLabel;
window._formatDate = _formatDate;
